import React, { useEffect, useMemo, useState } from "react";
import { TreeSelect } from "antd";
import { compose, flatten, includes, prop, sortBy, toLower } from "ramda";
import { useStaticData } from "../service/staticData.hooks";

export interface ITreeCategory {
  id: number;
  code: string;
  name: string;
  materialCode: string;
  materialDescription: string;
  materialLongDescription: string;
  active: boolean;
  spendCategories?: ITreeCategory[];
}
interface SpendCategoriesTreeViewProps {
    l1Id?: number;
    addRows: (input: any) => void;
  // Define your props here
}

// const treeData = [
//   {
//     title: "Node1",
//     value: "0-0",
//     children: [
//       {
//         title: "Child Node1",
//         value: "0-0-1",
//       },
//       {
//         title: "Child Node2",
//         value: "0-0-2",
//       },
//     ],
//   },
//   {
//     title: "Node2",
//     value: "0-1",
//   },
// ];

export const SpendCategoriesTreeView: React.FC<SpendCategoriesTreeViewProps> = (
  props: SpendCategoriesTreeViewProps
) => {
  const sortByCode = sortBy(compose(toLower, prop("code")));
  const { spendCategories } = useStaticData();
  const [value, setValue] = useState<string>();
  const treeData = useMemo(() => {
    return sortByCode(spendCategories)
      .filter((el) => !!el.active && (!props.l1Id || el.id === props.l1Id))
      .map((el: ITreeCategory) => ({
        title: el.code + " - " + el.name,
        code: el.code,
        id: el.id,
        isLeaf: false,
        value: `cat-${el.id}`,
        disabled: !!props.l1Id, //for performance purpouse
        children: sortByCode(el.spendCategories)
          .filter((el2) => !!el2.active)
          .map((el2: ITreeCategory) => ({
            title: el2.code + " - " + el2.name,
            code: el2.code,
            id: el2.id,
            isLeaf: false,
            value: `cat-${el.id}-${el2.id}`,
            children: sortByCode(el2.spendCategories)
              .filter((el3) =>  !!el3.active)
              .map((el3: ITreeCategory) => ({
                title: el3.code + " - " + el3.name,
                code: el3.code,
                id: el3.id,
                isLeaf: true,
                value: `cat-${el.id}-${el2.id}-${el3.id}`,
                mCode: el3.materialCode,
                mDesc: el3.materialDescription,
                mLongDesc: el3.materialLongDescription,
              })),
          })),
      }));
  }, [spendCategories]);

  useEffect(() => {
    console.log({ spendCategories });
  }, [spendCategories]);

  const onChange = async (selected) => {
    try {
      if (selected.length > 0) {
        const ids = selected.split("-");
        if (ids.length === 2) { //case L1
          const l1 = treeData.find(el => el.value === `${ids[0]}-${ids[1]}`);
          await props.addRows(flatten(l1.children.map(l2 => l2.children.map(l3 => ({
            l1Id: ids[1], l1Title: l1.title, l1Code: l1.code,
            l2Id: l2.id, l2Title: l2.title, l2Code: l2.code,
            l3Id: l3.id, l3Title: l3.title, l3Code: l3.code, mCode: l3.mCode, mDesc: l3.mDesc, mLongDesc: l3.mLongDesc
          })))));
        }
        if (ids.length === 3) { //case L2
          const l1 = treeData.find(el => el.value === `${ids[0]}-${ids[1]}`);
          const l2 = l1?.children.find(el => el.value === selected);
          await props.addRows(
              l2?.children.map(l3 => ({
                l1Id: ids[1], l1Title: l1.title, l1Code: l1.code,
                l2Id: ids[2], l2Title: l2.title, l2Code: l2.code,
                l3Id: l3.id, l3Title: l3.title, l3Code: l3.code, mCode: l3.mCode, mDesc: l3.mDesc, mLongDesc: l3.mLongDesc
              }))
          );
        }
        if (ids.length === 4) {
          const l1 = treeData.find(el => el.value === `${ids[0]}-${ids[1]}`);
          const l2 = l1?.children.find(el => el.value === `${ids[0]}-${ids[1]}-${ids[2]}`);
          const l3 = l2?.children.find(el => el.value === selected);
          await props.addRows(
              [{
                l1Id: ids[1],
                l1Title: l1.title,
                l1Code: l1.code,
                l2Id: ids[2],
                l2Title: l2.title,
                l2Code: l2.code,
                l3Id: ids[3],
                l3Title: l3.title,
                l3Code: l3.code,
                mCode: l3.mCode,
                mDesc: l3.mDesc,
                mLongDesc: l3.mLongDesc
              }]
            );
          }
        }
      } catch(e){
        console.log(e);
      }
      setValue(null)
    };

  return (
    <TreeSelect
    size="large"
      style={{ width: "100%" }}
      value={value}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      treeData={treeData}
      placeholder="+ Select category to add material..."
      treeDefaultExpandAll={false}
      onChange={onChange}
      showSearch
      allowClear
      filterTreeNode={(inputValue: string, treeNode: any) => {
        if (inputValue.length < 3) return false;
        let matchTitle = `${treeNode.title} ${
          treeNode.mCode !== undefined && treeNode.mCode !== null
            ? treeNode.mCode
            : ""
        } ${
          treeNode.mDesc !== undefined && treeNode.mDesc !== null
            ? treeNode.mDesc
            : ""
        }`;
        return includes(inputValue.toUpperCase(), matchTitle.toUpperCase());
      }}
    />
  );
};

export default SpendCategoriesTreeView;
